import { gql } from '@apollo/client';
import { creditApplicationOwnerFragment } from 'queries/fragments';
import { CREDIT_SUBMISSION_DECISION_FRAGMENT } from 'modules/creditSubmission';

export const GET_CREDIT_SUBMISSION = gql`
  query CreditSubmissionById($csId: ID!) {
    creditSubmission(dynamicsId: $csId) {
      closeInfo {
        id
        reasonId
        isClosed
        closeDealStatus
        reasonLabel
        closedDateTime
      }
      creditSubmissionId
      createdDateTime
      applicant
      amountRequested
      businessName
      creditSubId
      stage
      submissionDate
      decision
      dealer
      contactUserProfileId
      contact
      transactionId
      contactName
      contactPhone
      pgTransactionId
      voId
      dynamicsVOId
      lmsBookedData
      pgTransactionId
      dealerVendorProfile
      contactEmail
      invoiceTotal
      equipmentDescription
      equipmentApprovalStatus
      equipmentCondition
      equipmentCost
      freightLaborInstallation
      downPayment
      salesTaxOnInvoice
      dealerId
      lenderAccountId
      transactionSummary
      transactionSummaryBy
      dynamicsCreditApplicationId
      dynamicsApplicantId
      applicantAddress
      lenderDisplayNotify
      dynamicsLenderProfileId
      proposalV2Options
      creditSubmissionDeclineReasonId
      lenderProfiles {
        lenderName
        showCustomApp
        draftApplicationsEnabled
        pdfTemplate
        submissionMethod
        lenderProfileId
        lenderAccountId
        lenderContactId
        lenderChannelCode
        isCaptiveLender
        isDisabled
        isEnhancedSubmissionsFlowEnabled
      }
      masterCreditSubmissionId
      syndicatedBy {
        id
        email
        dynamicsContactId
        fullName
        title
        phoneNumber
        accountId
      }
      masterLenderName
      approvedRate
      notes
      contingencies
      approvedAmount
      lenderName
      fastTrackStatus
      fastTrackResults {
        creditSubmissionId
        fastTrackId
        applicationStatus
        rate
        approvedBy
        outputs {
          key
          value
        }
        inputs {
          key
          value
        }
      }
      scoreCardResult {
        creditTiersResultId
        vendorOpportunityId
        prescreenCriteriaId
        financeProgramId
        runtimeInput
        runtimeOutput
        result
        highestTierPassed
        tiersType
        highestTierColor
        createdDateTime
        modifiedDateTime
      }
      assignmentTitles {
        creditSubmissionAssignmentTitleId
        creditSubmissionId
        userProfileId
        title
        createdDateTime
        modifiedDateTime
        createdBy
        modifiedBy
      }
      customerAccountRecordDisplayId
      decisions {
        ...CreditSubmissionDecisionFields
      }
    }
  }
  ${CREDIT_SUBMISSION_DECISION_FRAGMENT}
`;

export const Q_CREDIT_APP = gql`
  query GetCreditApplication($VOId: ID!) {
    creditApplication(VOId: $VOId) {
      id
      dynamicsId
      amountRequested
      firstName
      lastName
      email
      businessName
      title
      phone
      bizPhone
      businessAddressCounty
      address
      city
      state
      stateOfIncorp
      postalCode
      equipmentDescription
      dba
      dateEstablished
      previousFinanceExp
      piecesOfTruckEqpt
      applicationType
      applyingFor
      creditLineAmountRequested
      creditLineStatus
      creditLineNotes
      industryType
      taxId
      createdDateTime
      needsRecertification
      ocaTemplateId
      yearsInBusiness
      bankruptcyDate
      ocaTemplate {
        vendorProfileId
        jsonDefinition
        name
      }
      location {
        locationId
        locationName
        category
      }
      equipments {
        equipmentId
        vendorOpportunityId
        quantity
        newUsed
        year
        make
        model
        serialNumberVin
        additionalDescription
        stockId
      }
      creditApplicationOwner {
        ...creditApplicationOwnerAttributes
      }
      creditApplicationContacts {
        ...creditApplicationOwnerAttributes
      }
    }
  }
  ${creditApplicationOwnerFragment}
`;

export const QUERY_PORTAL_CONFIGURATION = gql`
  query ($vendorProfileId: ID!, $types: [PortalConfigurationType]) {
    portalConfigurations(vendorProfileId: $vendorProfileId, types: $types) {
      portalConfigurationId
      vendorProfileId
      jsonDefinition
      type
    }
  }
`;

export const Q_EQUIPMENT = gql`
  query Equipments($id: ID, $VOId: ID) {
    equipments(id: $id, VOId: $VOId) {
      equipmentId
      vendorOpportunityId
      quantity
      newUsed
      year
      make
      model
      serialNumberVin
      additionalDescription
      stockId
      truckClass
      attachments
      wholesaleCost
      totalWholesaleCost
      retailPrice
      mileage
      assetTypeStr
      classType
      cabType
      term
      lenderProduct
      loanType
      hours
      type
      tradeInValue
      amountOwedOnTradeIn
      equipmentIdx
    }
  }
`;

export const M_BOOK_DEAL_LMS = gql`
  mutation bookDealLMS($input: BookDealLMSInput!) {
    bookDealLMS(input: $input)
  }
`;
